/* Package JSON Import will be here */
import React from "react";
import { Icon, Header, Segment, Table, Pagination, Button, Modal, Form, Input, Search, Confirm } from 'semantic-ui-react';
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../../src/config/appConstants';
// import './divisions.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import "./payRollNoteOptions.css";
import NoResultFound from "../sharedComponent/noResultFound";
/* Project Import will be here */

const PayRollNoteOptionComponent = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (

        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <span className="iconify myiconstyle_1" data-icon="mdi-file-edit-outline" data-inline="false" ></span>
                    <span>Payroll Note List</span>
                </Header>
                <i aria-hidden="true"
                    onClick={() => { props.onOpenModel({ data: {} }); }}
                    style={myiconstyle} className="plus circle icon">
                </i>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Payroll Note List
                            <Search className="theader" onSearchChange={props.onPayRollNoteOptionSearch}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.payRollNoteOption.payRollNoteOptionDataList && props.payRollNoteOption.payRollNoteOptionDataList.length > 0 ? props.payRollNoteOption.payRollNoteOptionDataList.map(({ name, id, status }) => (
                        <Table.Row style={{ verticalAlign: 'baseline' }}>
                            <Table.Cell textAlign="center" className="tableCell">
                                <div className="forcastIcon">
                                    <Icon className="myiconstyle" edit name='trash alternate outline'
                                        onClick={() => { props.onDeletePayRollNoteOption({ payRollNoteOptionId: id }); }}
                                    />
                                    <Icon className="myiconstyle" edit name='edit pencil'
                                        onClick={() => {
                                            props.onOpenModel({ payRollNoteOptionId: id });
                                        }}
                                    />
                                </div>
                            </Table.Cell>
                            <Table.Cell>{name}</Table.Cell>
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='2'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>

            <Modal closeIcon
                open={props.payRollNoteOption.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => { props.onCloseModel(); }}
                size='tiny'
            >
                <Modal.Header>{(props.payRollNoteOption.selectedValue && props.payRollNoteOption.selectedValue.payRollNoteOptionId > 0) ? "Edit Payroll Note" : "Add Payroll Note"}</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field required>
                                <label>Payroll Note List:</label>
                                <Input
                                    placeholder='Enter Payroll Note List'
                                    maxLength={50}
                                    value={props.payRollNoteOption.selectedValue ? props.payRollNoteOption.selectedValue.payRollNoteOptionName : ""}
                                    onChange={(e) => { props.handlePayRollNoteOptionChange(e, { name: 'payRollNoteOptionName', value: e.target.value }) }}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.payRollNoteOption.isEditPayRollNoteOption ?
                        <Button disabled={props.payRollNoteOption.isSetButtonDisabled} type="submit" primary onClick={() => props.onSavePayRollNoteOption(props.payRollNoteOption.selectedValue.payRollNoteOptionId)}> Update </Button> :
                        <Button disabled={props.payRollNoteOption.isSetButtonDisabled} type="submit" primary onClick={() => props.onSavePayRollNoteOption()}> Save </Button>
                    }
                    <Button secondary onClick={() => props.onCloseModel()} > Back </Button>
                </Modal.Actions>
            </Modal>
            <Confirm
                closeIcon
                open={props.payRollNoteOption.isDeleteConfiram}
                content="Are you sure? Do you want to delete this Payroll note?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.onCancelDelete(); }}
                onConfirm={() => { props.onConfirmDelete(); }}
            />
            {props.payRollNoteOption.payRollNoteOptionDataList && props.payRollNoteOption.payRollNoteOptionDataList.length > 0 &&
                <Pagination floated="right"
                    activePage={props.payRollNoteOption.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.payRollNoteOption.pagination.totalCount} />
            }
        </Layout >
    );
}

export default PayRollNoteOptionComponent;

PayRollNoteOptionComponent.displayName = "PayRollNoteOptionComponent";